export default __webpack_public_path__ + "static/media/invoice-sample.9d5b5210.jpg";